import { Wemi } from '@skinsoft/types'
import { itemSelectors, workSelectors, manifestationSelectors } from '.'
/**
 * Select work title first and fallback on manifestation title
 *  if first is null or empty
 * @param wemi 
 */
export const title = (wemi: Wemi, locale: string) => {
    return wemi.work && workSelectors.title(wemi.work, locale) ||
        wemi.manifestation && manifestationSelectors.title(wemi.manifestation, locale);
}

// complex fields
export const creationDate = (wemi: Wemi) => {
    return workCreationDate(wemi) ?? itemCreationDate(wemi) ?? "";
}

// item fields
const itemCreationDate = (wemi: Wemi) => wemi.item ? itemSelectors.creationDate(wemi.item) : ""
export const id = (wemi: Wemi) => wemi.item ? itemSelectors.id(wemi.item) : "";
export const itemType = (wemi: Wemi) => wemi.item ? itemSelectors.type(wemi.item) : "";
export const institution = (wemi: Wemi) => wemi.item ? itemSelectors.institution(wemi.item) : "";
export const inventoryNumber = (wemi: Wemi, locale: string) => wemi.item ? itemSelectors.identifier(wemi.item, locale) : "";
export const media = (wemi: Wemi) => wemi.item ? itemSelectors.media(wemi.item) : ""
export const lastDateOfConditionReport = (wemi: Wemi) => wemi.item ? itemSelectors.lastDateOfConditionReport(wemi.item) : "";
export const lastConditionReport = (wemi: Wemi) => wemi.item ? itemSelectors.lastConditionReport(wemi.item) : "";

// work fields
export const credits = (wemi: Wemi) => wemi.work ? workSelectors.credits(wemi.work) : null as any; // author name and function
export const workId = (wemi: Wemi) => wemi.work ? workSelectors.id(wemi.work) : "";
export const workType = (wemi: Wemi) => wemi.work ? workSelectors.workType(wemi.work) : "";
const workCreationDate = (wemi: Wemi) => wemi.work ? workSelectors.creationDate(wemi.work) : "";

// manifestations fields
export const manifestationId = (wemi: Wemi) => wemi.manifestation ? manifestationSelectors.id(wemi.manifestation) : "";
export const domain = (wemi: Wemi) => wemi.manifestation ? manifestationSelectors.domain(wemi.manifestation) : "";
export const denomination = (wemi: Wemi) => wemi.manifestation ? manifestationSelectors.name(wemi.manifestation) : "";
export const materialsAndTechnics = (wemi: Wemi) => wemi.manifestation ? manifestationSelectors.materialsAndTechnics(wemi.manifestation) : "";
export const measurements = (wemi: Wemi) => wemi.manifestation ? manifestationSelectors.measurements(wemi.manifestation) : "";


// expression fields
export const expressionId = (wemi: Wemi) => "" // unused for now but may be useful in the future

// other fields to complete
export const weight = (wemi: Wemi) => "";
